import React from 'react';
import { Notification } from '@honeycomb-npm/honeycomb-react';

import { DynamicContent } from '@commblades/commblades';

import { SubHeader } from './InSufficientBorrowingPower.styled';
import formatCurrency from '../../utils/formatCurrency';

interface InSufficientPowerProps {
    insufficientAmount: number;
    minimumLoanAmount: number;
    description:string;
    descriptionParas: string[];
    children?: React.ReactNode;
}

const InSufficientPower: React.FC<InSufficientPowerProps> = ({
    insufficientAmount, minimumLoanAmount, description, descriptionParas, children,
}) => (
    <div>
        <SubHeader>{`Your borrowing power is $${formatCurrency(insufficientAmount)}`}</SubHeader>
        <DynamicContent
            content={description}
            params={descriptionParas}
            id="insufficient-borrow-power-interest-description"
            className="mb-3"
            isParagraph
        />
        {children}
        <Notification
            heading={`Our minimum borrowing amount for a personal loan is $${formatCurrency(minimumLoanAmount)}`}
            headingTag="h4"
            isOpen
            isAutoFocus={false}
            type="info"
        >
            <p>
                Given your borrowing power is under the minimum loan amount, you should consider other options that may suit your needs.
            </p>
        </Notification>
    </div>
);

export default InSufficientPower;
